import { AI_ROADMAP } from "../content";
import { AiSectionHead } from "./AiSection";

/** 交付路线：三期阶段卡。对应设计稿第 8 节。 */
export default function AiRoadmap() {
  return (
    <section aria-labelledby="ai-roadmap-h" className="py-14 lg:py-20">
      <AiSectionHead eyebrow={AI_ROADMAP.eyebrow} title={AI_ROADMAP.title} sub={AI_ROADMAP.sub} />
      <div className="grid gap-5 lg:grid-cols-3">
        {AI_ROADMAP.phases.map((p) => (
          <article
            key={p.no}
            className="p-6 lg:px-6 lg:py-8 rounded-2xl bg-white border border-gray-200 shadow-[0_1px_2px_rgba(13,31,60,0.06)]"
          >
            <div className="flex items-center justify-between gap-3 mb-5">
              <span className="font-mono text-[11px] font-bold tracking-[0.1em] text-[#1a56db]">{p.no}</span>
              <span className="text-[11px] font-bold px-[9px] py-[3px] rounded-full bg-[#1a56db]/9 text-[#1a56db]">{p.level}</span>
            </div>
            <h3 className="text-[15px] font-bold text-[#0d1f3c] mb-5">{p.title}</h3>
            <ul className="m-0 p-0 list-none grid gap-3">
              {p.items.map((item) => (
                <li key={item.bold} className="grid grid-cols-[20px_minmax(0,1fr)] gap-3 text-sm text-[#475569] leading-relaxed">
                  <i className="ri-checkbox-circle-line text-[#059669] text-base leading-relaxed"></i>
                  <span>
                    <b className="text-[#0d1f3c]">{item.bold}</b>
                    {item.text}
                  </span>
                </li>
              ))}
            </ul>
          </article>
        ))}
      </div>
    </section>
  );
}
